import { render, staticRenderFns } from "./ANotificacionAll.vue?vue&type=template&id=5fca3205&scoped=true"
import script from "./ANotificacionAll.vue?vue&type=script&lang=js"
export * from "./ANotificacionAll.vue?vue&type=script&lang=js"
import style0 from "./ANotificacionAll.vue?vue&type=style&index=0&id=5fca3205&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca3205",
  null
  
)

export default component.exports